import { Stack } from "@chakra-ui/react"
import { Text } from "@/components"

interface Props {
  label: string,
  value: string,
}

export const TaxResultBox = ({ label, value }: Props) => {
  return (
    <Stack p={5} bg="card.bg" borderRadius={10}>
      <Text fontSize={12} color="text.primary">
        { label }
      </Text>
      <Text fontSize={20} color="text.primary" fontWeight="extrabold">
        { value }
      </Text>
    </Stack>
  )
}
